import { useSearchParams } from "react-router-dom";
import { useCollectionTypeShowQuery } from "@/admin/entities/collectionTypes";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

export function useCollectionTypesManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useCollectionTypeShowQuery(id, id === null);

  return {
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,
    getTableData,
    texts: getTextsConfig(),
  };
}
